import { IsObject } from '../../../helpers';
import { NOTIFICATIONS_OBSERVABLE_PRIVATE } from './privates';
import { Notification } from '../notification/implementation';
import { OBSERVER_PRIVATE } from '../../../core/observer/privates';
export function NormalizeNotificationsObservableMatchOptions(options = {}) {
    if (IsObject(options)) {
        const _options = {};
        _options.includeGlobalObservers = Boolean(options.includeGlobalObservers);
        return _options;
    }
    else {
        throw new TypeError(`Expected object or void as options`);
    }
}
export function NotificationsObservableDispatch(instance, name, value, notification) {
    const privates = instance[NOTIFICATIONS_OBSERVABLE_PRIVATE];
    if (privates.observersMap.has(name)) {
        const observers = privates.observersMap.get(name).slice(0);
        for (let i = 0, l = observers.length; i < l; i++) {
            observers[i].callback(value);
        }
    }
    const length = privates.othersObservers.length;
    if (length > 0) {
        if (notification === void 0) {
            notification = new Notification(name, value);
        }
        for (let i = 0; i < length; i++) {
            privates.othersObservers[i][OBSERVER_PRIVATE].onEmit(notification, instance);
        }
    }
}
//# sourceMappingURL=functions.js.map